import React from "react";
import Slider from "react-slick";
import "../../index.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
// import SvgShikshaFlower from "../shiksha logo_flower_png.svg";
// import BackgroundImage from "../happening-bg.jpg";

const Eventshome = ({ eventsData, currentLanguage }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    // arrows: true,
    arrows: false,     // Hide next/prev buttons

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div
      className="events-section mt-10 relative bg-beige bg-opacity-40 pb-16"
      // style={{
      //   backgroundImage: `url(${BackgroundImage})`,
      //   backgroundSize: "cover",
      //   backgroundAttachment: "fixed",
      //   backgroundBlendMode: "overlay",
      // }}
    >
      <div className="container mx-auto px-4 md:px-8 lg:px-12 xl:px-20 max-w-screen-xl pt-10">
        <h3 className="text-2xl sm:text-xl lg:text-3xl font-heading font-bold uppercase text-indian-red text-center relative">
          Events
          <div className="relative flex items-center justify-center line-with-image">
            <img src="/assets/SHIKSHA_Flower_SVG.svg" alt="headingflower" className="h-7 sm:h-6 lg:h-9 p-1 sm:p-2" />
          </div>
        </h3>

        {eventsData && eventsData.length > 0 ? (
          <Slider {...settings} className="relative events-carousel mt-1">
          {eventsData.map((event) => (
            <div
              key={event.id}
              className="event-card max-w-xs p-4 bg-white bg-opacity-80 rounded-lg shadow-lg overflow-hidden transition-transform duration-300 transform hover:scale-105"
            >
              <Link to={event.path}>
                <div className="w-full h-40 overflow-hidden flex justify-center items-center mb-3">
                  <img
                    src={event.imageAbout.url}
                    alt={event.imageAbout.alt || event.title}
                    className="object-cover w-full h-full rounded-md"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <h3 className="text-lg font-semibold font-body text-gray-800 truncate">
                  {event.title}
                </h3>
                <p className="text-sm font-body text-gray-700 overflow-hidden h-10 line-clamp-2" dangerouslySetInnerHTML={{ __html: event.body?.value || '' }}>
                  
                </p>
                <div className="text-center mt-3">
                  <Link to={event.path} className="text-indian-red font-body font-semibold hover:underline">
                    Read More
                  </Link>
                </div>
              </Link>
            </div>
          ))}
        </Slider>
        
        ) : (
          <p className="text-center text-lg text-white">No events available</p>
        )}
      </div>
    </div>
  );
};

export default Eventshome;
